






import {Component, Prop, Vue} from 'vue-property-decorator';
import Cover from '@/views/document/section/Cover.vue';

@Component({components: {Cover}})
export default class SectionEditor extends Vue {
  @Prop() readonly section!: any;

  get type() {
    return this.section.Type;
  }
  get subType() {
    return this.section.SubType;
  }
}
